import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grow,
  IconButton,
  Typography,
} from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import CloseIcon from "@material-ui/icons/Close";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";

const ConfirmationDialog = ({
  open,
  title = "Delete item?",
  message = "This action cannot be undone.",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  confirmColor = "#d32f2f",
  details,
  onConfirm,
  onCancel,
}) => (
  <Dialog
    open={open}
    onClose={onCancel}
    maxWidth="xs"
    fullWidth
    aria-labelledby="confirmation-dialog-title"
    TransitionComponent={Grow}
    BackdropProps={{ style: { backdropFilter: "blur(3px)", backgroundColor: "rgba(15,23,42,0.35)" } }}
  >
    <DialogTitle id="confirmation-dialog-title" disableTypography style={{ padding: "20px 24px 14px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div
          aria-hidden="true"
          style={{
            width: 42,
            height: 42,
            borderRadius: "50%",
            display: "grid",
            placeItems: "center",
            backgroundColor: "#ffebee",
            color: "#d32f2f",
          }}
        >
          <WarningRoundedIcon />
        </div>
        <Typography variant="h6" style={{ flex: 1, fontWeight: 700 }}>
          {title}
        </Typography>
        <IconButton aria-label="Close confirmation" size="small" onClick={onCancel}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>
    </DialogTitle>
    <Divider />
    <DialogContent style={{ padding: "18px 24px" }}>
      {details && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            padding: "12px 14px",
            backgroundColor: "#f8fafc",
            border: "1px solid #e2e8f0",
            borderRadius: 8,
            marginBottom: 14,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 6 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              {details.docNumber && (
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "2px 8px",
                    borderRadius: "6px",
                    backgroundColor: "#fff7ed",
                    color: "#c2410c",
                    border: "1px solid #fed7aa",
                    fontWeight: 700,
                    fontSize: "0.8125rem",
                    fontFamily: "monospace",
                    letterSpacing: "0.02em",
                  }}
                >
                  {details.docNumber}
                </span>
              )}
              {details.status && (
                <span
                  style={{
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    padding: "2px 6px",
                    borderRadius: "4px",
                    backgroundColor: "#e0e7ff",
                    color: "#3730a3",
                  }}
                >
                  {details.status}
                </span>
              )}
            </div>
            {details.amount != null && (
              <span style={{ fontSize: "0.875rem", fontWeight: 700, color: "#0f172a" }}>
                {details.currencySymbol ? `${details.currencySymbol} ` : ""}{typeof details.amount === "number" ? details.amount.toFixed(2) : details.amount}
              </span>
            )}
          </div>
          {(details.partyName || details.extra || details.date) && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "0.8125rem", color: "#475569", flexWrap: "wrap", gap: 6 }}>
              {details.partyName && (
                <div>
                  <span style={{ color: "#94a3b8", fontWeight: 500 }}>{details.partyType ? `${details.partyType}: ` : "Name: "}</span>
                  <strong style={{ color: "#1e293b" }}>{details.partyName}</strong>
                  {details.extra ? ` (${details.extra})` : ""}
                </div>
              )}
              {!details.partyName && details.extra && (
                <div>
                  <span style={{ color: "#475569" }}>{details.extra}</span>
                </div>
              )}
              {details.date && (
                <div style={{ color: "#64748b", fontSize: "0.75rem" }}>
                  {details.date}
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <Typography variant="body2" color="textSecondary">
        {message}
      </Typography>
    </DialogContent>
    <DialogActions style={{ padding: "8px 24px 20px", gap: 8 }}>
      <Button onClick={onCancel} variant="outlined" color="default">
        {cancelLabel}
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        startIcon={confirmLabel === "Delete" ? <DeleteOutlineIcon /> : undefined}
        style={{ backgroundColor: confirmColor, color: "#fff" }}
      >
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmationDialog;
